import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export const REASONS = [["injury", "Injury"], ["health", "Health/Veterinary Concern"], ["seller_decision", "Seller Decision"], ["other", "Other"]];

export function WithdrawFields({ v, setV }) {
  return (
    <div data-testid="withdraw-fields" className="space-y-3">
      <div className="space-y-1">
        <Label className="text-xs">Reason (optional)</Label>
        <select data-testid="withdraw-reason" value={v.withdrawal_reason} onChange={(e) => setV({ ...v, withdrawal_reason: e.target.value })}
          className="h-11 w-full rounded-md border border-stone-300 bg-white px-3 text-base sm:text-sm">
          <option value="">No reason given</option>
          {REASONS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
      </div>
      <div className="space-y-1">
        <Label className="text-xs">Explanation (optional, private)</Label>
        <Textarea data-testid="withdraw-explanation" rows={2} value={v.withdrawal_explanation} onChange={(e) => setV({ ...v, withdrawal_explanation: e.target.value })} className="text-base sm:text-sm" />
      </div>
      <label className="flex items-center gap-2 text-sm text-stone-800">
        <Checkbox data-testid="withdraw-hide-website" checked={v.hide} onCheckedChange={(x) => setV({ ...v, hide: !!x })} />Hide from website
      </label>
    </div>
  );
}
